
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppVersionService } from '../../services/app-version.service';

/**
 * Component that displays a notification when a new version of the app is available.
 *
 * Shows a banner at the top of the page with a message and a reload button.
 */
@Component({
  selector: 'app-version-update-notification',
  standalone: true,
  imports: [],
  templateUrl: './version-update-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './version-update-notification.component.scss',
})
export class VersionUpdateNotificationComponent {
  protected readonly versionService = inject(AppVersionService);

  // Expose signals for template
  protected readonly isUpdateAvailable = this.versionService.isUpdateAvailable;

  /**
   * Reload the application to get the latest version.
   */
  onReload(): void {
    this.versionService.reloadApp();
  }

  /**
   * Check if the notification should be shown.
   */
  shouldShow(): boolean {
    return this.isUpdateAvailable();
  }
}
